import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Lookup } from '../models/lookupmodel';
import { TransactionChart } from '../models/chartmodel';
import { Stat } from '../models/statmodel';
import { Cummulative } from '../models/cummulativemodel';
import { Recon } from '../models/reconmodel';
import { Search } from '../models/searchmodel';
import { AcctResponse } from '../models/accountresponse';
import { Observable } from 'rxjs/Rx';
import { SharedService } from '../services/sharedservices.service';
import { config } from '../config/config';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class paymentService {
  authconfig: string = config.username + ':' + config.password;
  postLookupUrl: string = config.baseEndpoint + 'Vendor/Lookup';
  postPaymentUrl: string = config.baseEndpoint + 'Vendor/SinglePayment';

  constructor(private http: Http, private sharedservice: SharedService) { }

 /* createAuthorizationHeader(headers: Headers) {
    let conversionSessionOutput = CryptoJS.AES.decrypt(localStorage.getItem("access_token"), config.key).toString(CryptoJS.enc.Utf8);
    let authconfig = this.sharedservice.session.account_username + ':' + conversionSessionOutput;
    headers.append('Authorization', 'Basic ' +
      btoa(authconfig));
  }*/

  accountLookup(request: Lookup): Observable<string> {
    const headers = new Headers();

    let req = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><PayUVasRequest><MerchantId>' + this.sharedservice.session.account_username +
      '</MerchantId><MerchantReference>' + this.sharedservice.session.account_username + this.sharedservice.newGuid() + '</MerchantReference><TransactionType>ACCOUNT_LOOKUP</TransactionType>' +
      '<VasId>MCA_ACCOUNT_SQ_NG</VasId><CountryCode>NG</CountryCode><CustomerId>' + request.smartcard +
      '</CustomerId></PayUVasRequest>';

    const params = new URLSearchParams;
    params.append('xml', req);

    // this.createAuthorizationHeader(headers);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post(this.postLookupUrl, params.toString(), {
      headers: headers,
      withCredentials: true
    })
      .map(res => res)
      .catch(this.handleError);
  }

  provisionAccount(request: Lookup): Observable<string> {
    const headers = new Headers();

    let req = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><PayUVasRequest><MerchantId>' + this.sharedservice.session.account_username +
      '</MerchantId><MerchantReference>' + this.sharedservice.session.account_username + this.sharedservice.newGuid() + '</MerchantReference><TransactionType>PROVISION</TransactionType>' +
      '<VasId>MCA_ACCOUNT_SQ_NG</VasId><CountryCode>NG</CountryCode><CustomerId>' + request.smartcard +
      '</CustomerId></PayUVasRequest>';

    const params = new URLSearchParams;
    params.append('xml', req);

    // this.createAuthorizationHeader(headers);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post(this.postLookupUrl, params.toString(), {
      headers: headers,
      withCredentials: true
    })
      .map(res => res)
      .catch(this.handleError);
  }

  singlePayment(request: Lookup): Observable<string> {
    const headers = new Headers();

    const req = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><PayUVasRequest><MerchantId>' + this.sharedservice.session.account_username +
      '</MerchantId><MerchantReference>' + this.sharedservice.session.account_username + this.sharedservice.newGuid() + '</MerchantReference><TransactionType>ACCOUNT_LOOKUP</TransactionType>' +
      '<VasId>MCA_ACCOUNT_SQ_NG</VasId><CountryCode>NG</CountryCode><CustomerId>' + request.smartcard +
      '</CustomerId></PayUVasRequest>';

    const params = new URLSearchParams;
    params.append('xml', req);

    // this.createAuthorizationHeader(headers);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post(this.postLookupUrl, params.toString(), {
      headers: headers,
      withCredentials: true
    })
      .map(res => res)
      .catch(this.handleError);
  }


  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/services/payment.service.ts